import classNames from "classnames";
import type { ComponentPropsWithRef, ReactNode } from "react";
import { forwardRef } from "react";

export interface RootProps extends ComponentPropsWithRef<"div"> {
  children: ReactNode;
}

export const RootBlock = forwardRef<HTMLDivElement, RootProps>(
  ({ children, className, ...rest }, ref) => (
    <div
      ref={ref}
      className={classNames(
        "wb-bg-primary wb-relative wb-h-full wb-w-full",
        className,
      )}
      {...rest}
    >
      {children}
    </div>
  ),
);

RootBlock.displayName = "Root";
